import React, { useEffect, useState, useContext } from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  IconButton,
  Dialog,
  Button,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AlertConfigCard from './AlertConfigCard';
import Copyright from '../internals/components/Copyright';
import { useGrowSetup } from '../GrowSetupContext';
import { AuthContext } from "./signin/AuthContext";
import axios from 'axios';

export default function AlertMainGrid() {
  const [alerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { grow_setup } = useGrowSetup();
  const { token } = useContext(AuthContext);

  const [openNew, setOpenNew] = useState(false);
  const handleOpenNew = () => setOpenNew(true);
  const handleCloseNew = () => setOpenNew(false);

  useEffect(() => {
    const fetchAlerts = async () => {
      if (!grow_setup) return;
      try {
        const response = await axios.post(
          `/get_alert_config/${grow_setup}`,
          {},
          { headers: { Authorization: 'Bearer ' + token } }
        );
        setAlerts(response.data || []);
      } catch (err) {
        console.error('Fehler beim Laden der Alerts', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAlerts();
  }, [grow_setup, token]);

  const handleAddNew = () => {
    handleOpenNew();
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { md: '800px' }, mb: 4, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Benachrichtigungs-Übersicht
      </Typography>

      <Grid container spacing={3}>
        {!isLoading && alerts.map((cfg, idx) => (
          <Grid key={idx} item xs={12} sm={6}>
            <AlertConfigCard
              {...cfg}
              grow_setup={grow_setup}
              token={token}
            />
          </Grid>
        ))}

        <Grid item xs={12} sm={6}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardActionArea
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: 2,
              }}
              onClick={handleAddNew}
            >
              <IconButton color="primary" sx={{ fontSize: 48 }}>
                <AddCircleOutlineIcon fontSize="inherit" />
              </IconButton>
              <CardContent>
                <Typography variant="body1" color="textSecondary">
                  Neue Benachrichtigung
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={openNew}
        onClose={handleCloseNew}
        
        maxWidth="sx"
        PaperProps={{
          sx: {
            background: 'transparent',
            boxShadow: 'none',
            overflow: 'visible',
          },
        }}
        BackdropProps={{
          sx: { backgroundColor: 'rgba(0,0,0,0)' },
        }}
      >
        <AlertConfigCard
          grow_setup={grow_setup}
          token={token}
          measure=""
          initialConfig={{}}
        />
        <Button
          onClick={handleCloseNew}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          Abbrechen
        </Button>
      </Dialog>

      <Box sx={{ mt: 4 }}>
        <Copyright />
      </Box>
    </Box>
  );
}
